/**
 * The flat set of back-office abilities. Each gated admin route belongs to
 * exactly one ability. An admin carries a subset of these; the PDP and the
 * per-route check are introduced in a later phase. Shared vocabulary between
 * backend gating and frontend UI gating.
 */
export enum AdminAbility {
  AdminsManage = "admins.manage",
  CorrectionsManage = "corrections.manage",
  SettingsManage = "settings.manage",
}
